export const ATTENDANCE_PAGE = {
  WORKING: "working",
  HOLIDAY: "holiday",
  LEAVE: "leave",
  SHIFTS: "shifts",
  WORKFLOW: "workflow",
  BEPERFROM: "bePerform",
  CONFIGBESMART: "configBesmart"
};

export const ATTENDANCE_PAGE_LIST = Object.values(ATTENDANCE_PAGE);
